import { getVideo, updateVideoLikeUnlike } from "./videoAPI";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

const initialState = {
    video: {},
    isLoading: false,
    isError: false,
    error: "",
};

// async thunk
export const fetchVideo = createAsyncThunk("video/fetchVideo", async (id) => {
    const video = await getVideo(id);
    return video;
});

// async thunk
export const updateVideoLikseUnlikes = createAsyncThunk("video/updateVideoLikeUnlike", async (id, likes, unlikes) => {
    const video = await updateVideoLikeUnlike(id, likes, unlikes);
    return video;
});

const videoSlice = createSlice({
    name: "video",
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(fetchVideo.pending, (state) => {
                state.isError = false;
                state.isLoading = true;
            })
            .addCase(fetchVideo.fulfilled, (state, action) => {
                state.isLoading = false;
                state.video = action.payload;
            })
            .addCase(fetchVideo.rejected, (state, action) => {
                state.isLoading = false;
                state.video = {};
                state.isError = true;
                state.error = action.error?.message;
            }).addCase(updateVideoLikseUnlikes.pending, (state) => {
                state.isLoading = true;
            }).addCase(updateVideoLikseUnlikes.fulfilled, (state) => {
                state.isLoading = false;
            }).addCase(updateVideoLikseUnlikes.rejected, (state) => {
                state.isLoading = false;
            });
    },
});

export default videoSlice.reducer;
